// extracted by mini-css-extract-plugin
module.exports = {"contentPage":"contentPage_contentPage__GtoGM","heading":"contentPage_heading__COCGv","image":"contentPage_image__Vgw2Y","list":"contentPage_list__yuDCq"};